import http from './http';

const update = (data) => {
  return http.put('profile', data);
};

export default { update};